import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';

import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { ANALYTICS_CONSTANTS } from 'config';
import { CartModel } from './../../../../../models';
import { UtilityService, HttpClientService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';

declare var ENV_PORTAL;
@Injectable()
export class BillingPaymentService {

  constructor(private http: HttpClient,
    private httpClientService: HttpClientService, private adobeAnalyticsService: AdobeAnalyticsService) { }

  validateSelectedFan(getFanDetailService, lineItems, fan) {
    const fanObj = {};
    fanObj['fan'] = fan;
    fanObj['lineItems'] = lineItems;
    return this.httpClientService.authorizedPost(getFanDetailService, fanObj)
      .pipe(
       map((resp: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(resp);
        return resp.body;
      })
      ,catchError( this.handleError ));
  }

  getBanDetailsGnFan(getBanDetailService, fan) {
    const fanObj = {};
    fanObj['fan'] = fan;
    return this.httpClientService.authorizedPost(getBanDetailService, fanObj)
      .pipe(
       map((resp: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(resp);
        return resp.body;
      })
      ,catchError( this.handleError ));
  }

  getCtnDetailsGnBan(getCtnDetailService, ban) {
    const banObj = {};
    banObj['ban'] = ban.value;
    return this.httpClientService.authorizedPost(getCtnDetailService, banObj)
      .pipe(
       map((resp: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(resp);
        return resp.body;
      })
      ,catchError( this.handleError ));
  }

  // Page Load abode analytics property creator
  createPageLoadProperties(cart: CartModel, url: string, title: string) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_BILLING_PAYMENT;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_CHECKOUT;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    let sku;
    for (const lineItem of cart.lineItems) {
      sku = (sku === undefined) ? lineItem.sku.socCode : sku + '|' + lineItem.sku.socCode;
    }
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SKU] = sku;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Sales';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_ABS_CHECKOUT_STEP] = title;   
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }

  // billing form submit abode analytics property creator
  createBillingFormSubmitLoadProperties(cart, status: string, event: string, errorCode?: string, errorText?: string) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.EVENT_EVENT_CODE] = ANALYTICS_CONSTANTS.EVENT_CODE_BILLING_CHECKOUT;

    if (status === 'SUCCESS') {
      dataLayer[ANALYTICS_CONSTANTS.EVENT_ITEMS] = [];
      for (const item of cart.lineItems) {
        const sku = { 'itemSku': item.sku.socCode };
        dataLayer[ANALYTICS_CONSTANTS.EVENT_ITEMS].push(sku);
      }
      dataLayer[ANALYTICS_CONSTANTS.EVENT_SUCCESS_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_1;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_ERROR_TYPE] = ANALYTICS_CONSTANTS.EVENT_ERROR_SUCCESS_TYPE;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_CODE] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_0;
    } else {
      dataLayer[ANALYTICS_CONSTANTS.EVENT_SUCCESS_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_0;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_ERROR_TYPE] = ANALYTICS_CONSTANTS.EVENT_ERROR_FAILURE_TYPE_FAILURE_SYSTEM;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_CODE] = errorCode;
      // dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_MESSAGE] = errorText;
    }
    this.adobeAnalyticsService.tag('event', dataLayer, ANALYTICS_CONSTANTS.EVENT_CODE_BILLING_CHECKOUT, event);
  }

  handleError = (error) => {
    return throwError(error);
  }
}

